/* global axios */
import ApiClient from 'dashboard/api/ApiClient';

// Campaign Center API (/api/v1/accounts/:id/wasapi/campaigns...)
class CampaignCenterAPI extends ApiClient {
  constructor() {
    super('wasapi/campaigns', { accountScoped: true });
  }

  list(params = {}) {
    return axios.get(this.url, { params });
  }

  get(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(campaign, status = 'draft') {
    return axios.post(this.url, { campaign, status });
  }

  update(id, campaign, status) {
    return axios.patch(`${this.url}/${id}`, { campaign, status });
  }

  destroy(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  schedule(id, scheduledAt) {
    return axios.post(`${this.url}/${id}/schedule`, {
      scheduled_at: scheduledAt,
    });
  }

  unschedule(id) {
    return axios.post(`${this.url}/${id}/unschedule`);
  }

  pause(id) {
    return axios.post(`${this.url}/${id}/pause`);
  }

  resume(id) {
    return axios.post(`${this.url}/${id}/resume`);
  }

  cancel(id) {
    return axios.post(`${this.url}/${id}/cancel`);
  }

  duplicate(id) {
    return axios.post(`${this.url}/${id}/duplicate`);
  }

  testSend(id, { contactId, phoneNumber }) {
    return axios.post(`${this.url}/${id}/test_send`, {
      contact_id: contactId,
      phone_number: phoneNumber,
    });
  }

  recipients(id, params = {}) {
    return axios.get(`${this.url}/${id}/recipients`, { params });
  }

  events(id) {
    return axios.get(`${this.url}/${id}/events`);
  }

  // saved campaign → GET member; unsaved form values → POST collection
  audiencePreview(id, params = {}) {
    if (id) return axios.get(`${this.url}/${id}/audience_preview`, { params });
    return axios.post(`${this.url}/audience_preview`, params);
  }

  messagePreview(id, { campaign, contactId }) {
    if (id) {
      return axios.get(`${this.url}/${id}/message_preview`, {
        params: { contact_id: contactId },
      });
    }
    return axios.post(`${this.url}/message_preview`, {
      campaign,
      contact_id: contactId,
    });
  }

  settings() {
    return axios.get(`${this.baseUrl()}/wasapi/campaign_settings`);
  }

  updateSettings(payload) {
    return axios.put(`${this.baseUrl()}/wasapi/campaign_settings`, payload);
  }

  blacklist(params = {}) {
    return axios.get(`${this.baseUrl()}/wasapi/campaign_blacklists`, {
      params,
    });
  }

  addToBlacklist(phoneNumber, reason) {
    return axios.post(`${this.baseUrl()}/wasapi/campaign_blacklists`, {
      phone_number: phoneNumber,
      reason,
    });
  }

  importBlacklist(numbers, reason) {
    return axios.post(`${this.baseUrl()}/wasapi/campaign_blacklists/import`, {
      numbers,
      reason,
    });
  }

  removeFromBlacklist(id) {
    return axios.delete(`${this.baseUrl()}/wasapi/campaign_blacklists/${id}`);
  }
}

export default new CampaignCenterAPI();
